import { useState } from "react";
import { Box, Button, Card, Typography } from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import { mfaValidateRequest } from "../../utils/APICalls";
import ErrorNotification from "../../components/error-notification/error-notification";
import Loading from "../../components/loading/loading";
import OtpInput from "react-otp-input";
import { setReturnUrl } from "../../utils/SingletonStore";

export default function OTPPage() {
  const { state } = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [showLoading, setShowLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [showErrorNotification, setShowErrorNotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const mfaValidate = async () => {
    const payload = {
      code: otp,
      session: state?.session,
    };
    setShowLoading(true);
    const response = await mfaValidateRequest(payload);
    setShowLoading(false);
    if (response?.status === 200) {
      localStorage.setItem("accessToken", response?.data?.accessToken);
      localStorage.setItem("refreshToken", response?.data?.refreshToken);
      const returnUrl = searchParams.get("returnUrl");
      setReturnUrl(null);
      if (returnUrl) {
        navigate(returnUrl, { replace: true })
      } else {
        navigate("/all-orders");
      }
    } else if (response?.status === 400 || response?.status === 404) {
      setShowErrorNotification(true);
      setErrorMessage(response?.data?.detail);
    }
  };

  return (
    <Box className="backgroud-layout">
      <Box className="signin-layout">
        <Card className="signin-card">
          <img
            className="signin-logo"
            src={require("../../assets/Vision_Logo.svg").default}
            alt="logo"
          />
          <Typography className="signin-text" variant="h5">
            Authenticator App MFA
          </Typography>
          <Box sx={{ display: "flex", mt: 3, mx: 3 }}>
            <Typography sx={{ ml: 0.5, mr: 2, textAlign: "left" }}>
              To complete sign in, enter the 6 digit code from your
              authenticator app.
            </Typography>
            <PhoneAndroidOutlinedIcon
              sx={{ width: 48, height: 48, color: "rgba(0, 0, 0, 0.6)" }}
            />
          </Box>
          <OtpInput
            containerStyle={{ margin: "24px 12px 0px 8px" }}
            inputStyle={{
              height: 56,
              width: 56,
              marginLeft: 18,
              borderColor: "rgba(0, 0, 0, 0.23)",
              borderWidth: 1,
              borderRadius: 4,
              fontSize: 34,
            }}
            value={otp}
            onChange={setOtp}
            numInputs={6}
            inputType="tel"
            renderInput={(props) => <input {...props} />}
          />
          <Button
            sx={{ mt: 3, height: 42, width: "calc(100% - 48px)" }}
            disabled={otp.length !== 6}
            className="signin-button"
            variant="contained"
            onClick={mfaValidate}
          >
            Sign In
          </Button>
        </Card>
      </Box>
      {showErrorNotification && (
        <ErrorNotification
          show={showErrorNotification}
          onClose={() => setShowErrorNotification(false)}
          title={errorMessage}
        />
      )}
      {showLoading && <Loading />}
    </Box>
  );
}
